import { jsx as a } from "react/jsx-runtime";
import { c as m } from "../../vendor-CwFtm_qv.js";
import { forwardRef as r } from "react";
import { omit as v } from "../../utils/omit/index.js";
import { BaseIcon as _ } from "../BaseIcon/index.js";
import '../../assets/index5.css';const u = "_5yvvZG_blue", y = "_5yvvZG_cactus", d = "_5yvvZG_calloutIcon", i = "_5yvvZG_gold", p = "_5yvvZG_green", G = "_5yvvZG_magenta", Z = "_5yvvZG_md", g = "_5yvvZG_moon", f = "_5yvvZG_purple", I = "_5yvvZG_red", x = "_5yvvZG_sienna", b = "_5yvvZG_sm", z = "_5yvvZG_teal", o = {
  blue: u,
  cactus: y,
  calloutIcon: d,
  gold: i,
  green: p,
  magenta: G,
  md: Z,
  moon: g,
  purple: f,
  red: I,
  sienna: x,
  sm: b,
  teal: z
}, N = {
  sm: "lg",
  md: "xl"
}, M = r(
  ({ icon: n, color: s = "moon", size: t = "md", ...c }, e) => {
    const l = {
      [o.calloutIcon]: !0,
      [o[s]]: !0,
      [o[t]]: !0
    };
    return /* @__PURE__ */ a(
      _,
      {
        ...v(c, ["className", "style", "slot", "children", "icon", "size", "color"]),
        ref: e,
        icon: n,
        size: N[t],
        color: s,
        className: m(l)
      }
    );
  }
);
export {
  M as CalloutIcon
};
//# sourceMappingURL=index.js.map
